import { forwardRef } from '@chakra-ui/system';

import { InputRightElement } from '@frontend/components';
import {
  AssistanceApprovedIcon,
  AssistanceAvailableIcon,
  AssistanceRejectedIcon,
} from '@frontend/components/src/components/mediaAndIcons/icons/iconSet';

import { useInputGroupWithSuggestionsContext } from './';

export const InputGroupWithSuggestionsRightElement = forwardRef(
  (props, ref) => {
    const { availableSuggestions, acceptedSuggestion, isDisabled } =
      useInputGroupWithSuggestionsContext();

    return (
      <InputRightElement
        ref={ref}
        h={4}
        overflow="hidden"
        pointerEvents="none"
        size="sm"
        zIndex="auto"
        {...props}
        {...(availableSuggestions && {
          w: 8,
        })}
      >
        {!isDisabled &&
          (availableSuggestions ? (
            <>
              <AssistanceAvailableIcon
                boxSize="1.375rem"
                color="alert.assistance"
                top="0.3125rem"
                right="0.3125rem"
                position="absolute"
              />
            </>
          ) : acceptedSuggestion ? (
            <AssistanceApprovedIcon
              boxSize="1.375rem"
              color="alert.assistance"
              top="0.3125rem"
              right="0.3125rem"
              position="absolute"
            />
          ) : (
            <>
              <AssistanceRejectedIcon
                boxSize="1.375rem"
                top="0.3125rem"
                right="0.3125rem"
                color="feature.placeholder"
                position="absolute"
              />
            </>
          ))}
      </InputRightElement>
    );
  },
);
